module.exports = __webpack_public_path__ + "img/BAU Seniors_31.476ca7dd.jpg";